import React, { ReactElement, memo, ReactNode, useCallback } from "react";
import cx from "classnames";
import styles from "./Header.scss";
import { BackIcon } from "@swiggy-private/core-ui";
import { withStyles } from "@swiggy-private/core-ui";
import { useOnBack } from "@swiggy-private/checkout-core";

// test-ids
import { COMMON_HEADER_TEST_IDS } from "@swiggy-private/payment-test-ids";

//constants
import { ACCESSIBILITY_TEXTS } from "@payment-client/constants/Header";

interface CommonHeaderProps {
    children: ReactNode;
    onBack?: VoidFunction;
    containerClass?: string;
    isVisible: boolean;
    backButtonClass?: string;
}

function BackButtonComponent(props: {
    className?: string;
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}): ReactElement {
    return (
        <button
            data-testid={COMMON_HEADER_TEST_IDS.BACK_BUTTON}
            className={props.className}
            onClick={props.onClick}
            aria-label={ACCESSIBILITY_TEXTS.GO_BACK}
        >
            <BackIcon />
        </button>
    );
}

const BackButton = React.memo(BackButtonComponent);

function CommonHeader(props: CommonHeaderProps): ReactElement {
    const { containerClass, backButtonClass, isVisible, children } = props;
    const onBack = useOnBack();
    const containerClassName = cx(styles.container, containerClass, {
        [styles.containerNotVisible]: !isVisible,
        [styles.containerUx4]: true,
    });

    const backButtonClassName = cx(styles.containerButton, backButtonClass, {
        [styles.containerButtonUx4]: true,
    });

    const onBackButtonClick = useCallback(
        (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            e.preventDefault();

            if (typeof props.onBack === "function") {
                props.onBack();
                return;
            }
            onBack();
        },
        [onBack, props],
    );

    return (
        <div className={containerClassName}>
            <BackButton onClick={onBackButtonClick} className={backButtonClassName} />
            <div className={styles.containerContent}>{children}</div>
        </div>
    );
}

export default memo(withStyles(CommonHeader, styles));
